import { useNavigate } from "react-router-dom";
import { Swords, ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div data-testid="privacy-policy-page" className="min-h-screen bg-zinc-950 flex flex-col">
      <header className="border-b border-amber-900/30 bg-zinc-900/40">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <button data-testid="privacy-back-btn" onClick={() => navigate("/")}
            className="flex items-center gap-2 text-zinc-400 hover:text-amber-300 transition-colors text-sm">
            <ArrowLeft size={16} /> Back
          </button>
          <div className="flex items-center gap-2.5">
            <Swords className="text-amber-500" size={18} />
            <span className="font-cinzel text-sm tracking-[0.25em] uppercase text-amber-300">Lanista — Gladiator Manager</span>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <iframe
          data-testid="privacy-policy-frame"
          title="Privacy Policy"
          src="/privacy-policy.html"
          className="w-full"
          style={{ height: "calc(100vh - 61px)", border: "none", background: "#fff" }}
        />
      </main>
    </div>
  );
}
